module.exports = __webpack_public_path__ + "img/logo.d9c7d186.png";